var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoV3Shadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 489.15 496.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#95b1db;}.cls-2{fill:#302e36;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.34,476.31C43.74,420.11,13.14,334,11.74,265.71c-5.9-303.5,410.2-357.1,479.1-55.9,2.8,12-.2,12.2-2.2,15.4-.5.8-37.1-7.6-38.9,1.9-18,95-160.1,103.8-139.6-4.7,16.4-86.5-8.4-82-15.7-69.9-58.1,97.5-164.5,40-132.8,136.9,9.7,29.6,36.2,44.4,54.9,45.5,52.6,3.1,79.9-23.5,81.5-26.2,0-.1.1-.1.1-.2h0a1.88,1.88,0,0,1,3.1,2.1c-3.8,6.6-9,14.2-15.2,20.1-12.7,11.8-41.7,22.3-76.6,23.8-62.2-3.5-86.2-37.2-90.8-105.3-1.7-25.1,67.2-37.3,104.5-56.8,74-38.7,59.9-54.9,78.7-60.2,7.2-2,35.2,10.2,27.7,57.6-20.2,114.9,89.5,98.7,109.5,34,2.9-9.3,13.4-5.5,25-6.4,10.4-.8,9.6-1.6,2.9-23.2C380.84-84.49,23.84,26.11,57,275c15.1,113.7,145.1,183.1,237.1,146,117.3-51.5,136.3-127.6,178-64.1,12.2,28.4-17.4,108.6-163.7,135.4C248.44,503.31,193.44,494.11,157.34,476.31Zm277.5-255.2Z",
    transform: "translate(-2.84 -1.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.84,237.31c-6,3.5-7.2,2.2-4.5-.7,3.4-3.6,27.3-24.8,39.3-3.6,4.4,7.8-8.1-.1-13.6-1.3C234.64,230.61,227.14,233.61,220.84,237.31Z",
    transform: "translate(-2.84 -1.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.94,218.31c-3.7,5.4-2.5,6.6.5,4.2,3.7-3.1,25.8-24.5,5.1-36.1-7.6-4.3-.2,7.4.8,12.6C396.14,205.71,392.94,212.51,388.94,218.31Z",
    transform: "translate(-2.84 -1.04)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-3",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.5,468.2C34.9,412,4.3,325.9,2.9,257.6-3-45.9,413.1-99.5,482,201.7c2.8,12-.2,12.2-2.2,15.4-.5.8-37.1-7.6-38.9,1.9-18,95-160.1,103.8-139.6-4.7,16.4-86.5-8.4-82-15.7-69.9-58.1,97.5-164.5,40-132.8,136.9,9.7,29.6,36.2,44.4,54.9,45.5,52.6,3.1,79.9-23.5,81.5-26.2,0-.1.1-.1.1-.2h0a1.88,1.88,0,0,1,3.1,2.1c-3.8,6.6-9,14.2-15.2,20.1-12.7,11.8-41.7,22.3-76.6,23.8-62.2-3.5-86.2-37.2-90.8-105.3-1.7-25.1,67.2-37.3,104.5-56.8,74-38.7,59.9-54.9,78.7-60.2,7.2-2,35.2,10.2,27.7,57.6-20.2,114.9,89.5,98.7,109.5,34,2.9-9.3,13.4-5.5,25-6.4,10.4-.8,9.6-1.6,2.9-23.2C372-92.6,15,18,48.2,266.9,63.3,380.6,193.3,450,285.3,412.9c117.3-51.5,136.3-127.6,178-64.1,12.2,28.4-17.4,108.6-163.7,135.4C239.6,495.2,184.6,486,148.5,468.2ZM426,213Z",
    transform: "translate(-2.84 -1.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212,229.2c-6,3.5-7.2,2.2-4.5-.7,3.4-3.6,27.3-24.8,39.3-3.6,4.4,7.8-8.1-.1-13.6-1.3C225.8,222.5,218.3,225.5,212,229.2Z",
    transform: "translate(-2.84 -1.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.1,210.2c-3.7,5.4-2.5,6.6.5,4.2,3.7-3.1,25.8-24.5,5.1-36.1-7.6-4.3-.2,7.4.8,12.6C387.3,197.6,384.1,204.4,380.1,210.2Z",
    transform: "translate(-2.84 -1.04)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoV3Shadow);
export default __webpack_public_path__ + "static/media/logo_v3_shadow.a20ba5880c22c81ba003d6aafe952ec8.svg";
export { ForwardRef as ReactComponent };